if(typeof TextilesSection !== 'function') {
  class TextilesSection extends HTMLElement {
    constructor() {
      super()
      this.dialog = this.querySelector('.collectionDialogContainer')
      this.grid = this.querySelector('.collection__products')
      this.prev = this.querySelector('.dialogControlPrev')
      this.next = this.querySelector('.dialogControlNext')

      this.init()
      document.addEventListener("shopify:section:load", (event) => {
        this.init()
      })
    }
    init() {
      const config = { childList: true, subtree: true}
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          this.action()
        }
      }
      const observer = new MutationObserver(callback)

      this.action()
      if(this.grid) {
        observer.observe(this.querySelector('.collection__products'), config)
      }
      
      // Dialog Controls
      this.dialog?.querySelector('.closeDialog')?.addEventListener('click', () => {
        this.dialog.close()
        this.dialog.querySelector('.dialogContext').innerHTML = ''
      })

      this.dialog?.addEventListener('click', (e) => {
        const dialogDimensions = this.dialog.getBoundingClientRect()
        if(e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) {
          this.dialog.close()
          this.dialog.querySelector('.dialogContext').innerHTML = ''

          this.prev?.removeEventListener('click', this.controls)
          this.next?.removeEventListener('click', this.controls)
        }
      })
    }
    controls(e) {
      const activeImage = this.closest('textiles-section').querySelector('.active-image')
      activeImage.classList.remove('active-image')

      if(e.target.dataset.action == "next") activeImage.nextElementSibling?.classList.add('active-image')
      else activeImage.previousElementSibling?.classList.add('active-image')
    }
    action() {
      this.textiles = this.querySelectorAll('.product-item__image-wrapper')
      Array.from(this.textiles).forEach(pi => {
        pi.addEventListener('click', (e) => {
          e.preventDefault()
          const images = JSON.parse(pi.dataset.images)
          const modal = pi.closest('.shopify-section').querySelector('.dialogContainer')

          // modal.querySelector('.dialogContext').innerHTML = pi.querySelector('.product-item__image').innerHTML
          modal.querySelector('.dialogContext').innerHTML = images.map((img, i) => `<img class="dialog_image__img${ i == 0 ? ' active-image' : '' }" src="${ img }">`).join('')

          this.prev?.addEventListener('click', this.controls)
          this.next?.addEventListener('click', this.controls)
          modal.showModal()
        })
      })
    }
  }

  customElements.define('textiles-section', TextilesSection)
}